import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getValueSetConceptsFromCodeSystemTerms = async (codeSystemFevirId, termCode, recursive, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with codesystemtermstovaluesetconcept")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "codesystemtermstovaluesetconcept",
            "apiToken": apiToken,
            'resourceid': codeSystemFevirId,
            'termcode': termCode,
            'recursive': recursive
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'valuesetincludeinstance': valueSetIncludeInstance, "codedisplay": codedisplay }
            if (resp.data.success && resp.data.valuesetincludeinstance) {
                //valuesetincludeinstance contains { system: url, version: string, concept: [] }
                return resp.data.valuesetincludeinstance;
            } else {
                console.log("FAILED RESPONSE from codesystemtermstovaluesetconcept call")
                return null;
            }
        }
        console.log("NO RESPONSE from codesystemtermstovaluesetconcept call");
    }).catch((error) => { console.log(error); });
}

export default getValueSetConceptsFromCodeSystemTerms;